import React, { useState, useEffect, useRef } from "react";
// import { createAvatar } from "@dicebear/core";
// import { thumbs } from "@dicebear/collection";
// import { FaChevronDown } from "react-icons/fa";
import LogoutWhite from "../assets/img/logoutwhite.png";

const HeaderAvatarMenu = ({ userDetails, onLogout, onProfile }) => {
  // const [avatarSeed, setAvatarSeed] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // useEffect(() => {
  //   // Persist a seed per browser so avatar stays stable within a session
  //   const key = "datalyze-avatar-seed";
  //   let stored = window.localStorage.getItem(key);
  //   if (!stored) {
  //     stored = Math.random().toString(36).substring(2);
  //     window.localStorage.setItem(key, stored);
  //   }
  //   setAvatarSeed(stored);
  // }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const avatarDataUri = useMemo(() => {
  //   if (!avatarSeed) return null;
  //   const avatar = createAvatar(thumbs, {
  //     seed: avatarSeed,
  //     backgroundColor: ["b6e3f4", "c0aede", "d1d4f9"],
  //     radius: 50,
  //   });

  //   const svg = avatar.toString();
  //   return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  // }, [avatarSeed]);

  const handleLogoutClick = async () => {
    setIsOpen(false);
    if (onLogout) {
      await onLogout();
    }
  };

  const handleProfileClick = () => {
    setIsOpen(false);
    if (onProfile) {
      onProfile();
    }
  };

  return (
    <div className="relative flex items-center gap-3" ref={menuRef}>
      
      {/* <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="relative flex items-center gap-1.5 rounded-full hover:shadow-md transition-shadow"
      >
        <span className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-black/5 bg-white shadow-sm flex items-center justify-center overflow-hidden">
          {avatarDataUri ? (
            <img
              src={avatarDataUri}
              alt="User avatar"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-exl-light-blue text-exl-midnight-blue font-bold">
              {(userDetails?.name?.[0] || "U").toUpperCase()}
            </div>
          )}
        </span>
        <FaChevronDown
          className={`w-3 h-3 text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
          aria-hidden
        />
      </button> */}

      {isOpen && (
        <div className="absolute right-0 top-[115%] w-56 rounded-2xl bg-white shadow-lg border border-black/5 py-2 z-50">
          <div className="px-3 pb-2 border-b border-black/5">
            <p className="text-xs font-medium text-gray-500">Signed in as</p>
            <p className="text-sm font-semibold text-gray-900 truncate">
              {userDetails?.name || "User"}
            </p>
            {userDetails?.email && (
              <p className="text-[11px] text-gray-500 truncate">
                {userDetails.email}
              </p>
            )}
          </div>

          <button
            type="button"
            onClick={handleProfileClick}
            className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-gray-50"
          >
            Settings
          </button>

          <button
            type="button"
            onClick={handleLogoutClick}
            className="w-full flex items-center justify-between gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 mt-1"
          >
            <span>Logout</span>
            <img
              src={LogoutWhite}
              className="w-[15px] h-[15px]"
              alt="logout"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default HeaderAvatarMenu;

